import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import ArrayUtil from '@leverege/array-util'
import { Text } from '@leverege/ui-elements'

import { NetworkActions, NetworkUpdater, BreadcrumbActions } from '~/actions'

import { List, SplitPane, Screen, YesNoDialog } from '~/views'
import NetworkItem from './NetworkItem'
import NoNetworksView from './NoNetworksView'
import { NetworkFactory, CustomNetworkDialog } from '~/editors/network'
import { TransferToProjectDialog } from '~/editors/project'

import style from './style.css'

class NetworksScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }
  
  constructor( props, context ) {
    super( props, context );
    this.onEvent = this.onEvent.bind( this );
    this.onNetworkChange = this.onNetworkChange.bind( this );
    this.state = { selectId : null, showCustom : false, showRest : false, transferItem : null, showTransfer : false }
  }

  componentDidMount() {
    this.props.dispatch( NetworkActions.getNetworks( this.props.match.params.projectId ) );
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Networks' } ] ) )
  }

  onEvent( event, item ) {
    if ( event == 'select' ) {
      this.setState( { selectId : item.id } );
    } else if ( event == NetworkItem.TRANSFER_EVENT ) {
      this.setState( { showTransfer : true, transferItem : item } )
    } else if ( event == NetworkItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeNetwork : item } )
    }
  }

  onTransfer = ( item, toProject ) => {
    this.onNetworkChange( { target : item, path : 'projectId', value : toProject.id } )
    this.setState( { showTransfer : false, transferItem : null } )
  }

  onPromptRemoveYes = () => {
    const { dispatch } = this.props
    const { removeNetwork } = this.state
    this.props.dispatch( NetworkActions.removeNetwork( removeNetwork ) );
    this.setState( { showRemoveDialog : false, removeNetwork : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeNetwork : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeNetwork : null } )
  }

  onNetworkChange( event ) {
    const { dispatch } = this.props

    NetworkUpdater( dispatch, event.target )
      .set( event.path, event.value )
      .done();
  }

  onCreateRestNetwork = ( ) => {
    const { params } = this.props.match
    if ( params && params.projectId ) {
      const net = { type : 'rest', name : 'My Rest Network' }
      this.props.dispatch( NetworkActions.addNetwork( params.projectId, net ) );
    }
  }

  onCreateCustomNetwork = ( ) => {
    this.setState( { showCustom : true } )
  }

  onCustomNetworkDialogDone = ( network ) => {
    const { params } = this.props.match
    this.setState( { showCustom : false } )
    this.props.dispatch( NetworkActions.addNetwork( params.projectId, network ) );
  }

  onCancel = () => {
    this.setState( { showCustom : false, showRest : false } )
  }
  
  render() {
    const { networks, projects } = this.props
    const projectNetworks = ( networks && networks.project ) || []

    const { selectId, removeNetwork, transferItem, showTransfer } = this.state;
    const isSelected = function( item ) { return item && item.id == selectId; }

    const list = (
      <List className={style.list}
        onEvent={this.onEvent}
        isSelected={isSelected}
        noItemsView={<NoNetworksView />}
        items={projectNetworks}
        itemView={NetworkItem} />
    );
    let details = null
    if ( selectId ) {
      // get the selected object
      const selected = ArrayUtil.find( projectNetworks, 'id', selectId )
      details = NetworkFactory.createEditor( selected, { network : selected, onChange : this.onNetworkChange } );
    }
    const right = <div className={style.right}>{details}</div>

    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <Text variant="screenTitle">Networks</Text>
          <span>
            <Button bsStyle="primary"
              className="add-button"
              style={{ marginLeft : '10px' }}
              onClick={this.onCreateCustomNetwork}> 
              <i className="fa fa-fw fa-circle-plus fa-lg" />
              {' '}
              Create Network
            </Button>
          </span>
        </Screen.Header>
        <Screen.Content>
          <SplitPane style={{ height : '100%' }} left={list} right={right} />
        </Screen.Content>

        <YesNoDialog show={this.state.showRemoveDialog} 
          title={`Remove ${removeNetwork && removeNetwork.name}?`}
          message={<div>Are you sure you want to delete the network. All devices using this network will lose their bindings to this network?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />

        {
          this.state.showCustom && <CustomNetworkDialog onCreate={this.onCustomNetworkDialogDone} onCancel={this.onCancel} />
        }

        <TransferToProjectDialog objType="Blueprint"
          object={transferItem}
          projects={projects}
          show={showTransfer}
          onCancel={() => { this.setState( { showTransfer : false, transferItem : null } ) }}
          onTransfer={this.onTransfer} />
      </Screen>
    );
  }
} 

export default connect(
  state => ( {
    networks : state.networks,
    projects : state.projects
  } )
)( NetworksScreen );
